import { Injectable, OnDestroy } from '@angular/core';

import { fuseConfig } from 'app/fuse-config';
import { FuseConfig } from '@fuse/types';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Subject, BehaviorSubject, Subscription, Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { timer } from 'rxjs';


@Injectable()
export class FaqService implements Resolve<any> {
    public _unsubscribeAll: Subject<any>;
    public _fuseConfig: FuseConfig;
    
    timer: Observable<number>;
    timerSubscription: Subscription;
    
    searchText: string;

    faq: any;
    onFaqChanged: BehaviorSubject<any>;
    
    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        public _httpClient: HttpClient,
        private _authService: AuthService,
    ) {
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();
        this.onFaqChanged = new BehaviorSubject({});

    }

    /**
     * Resolver
     *
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(): Observable<any> | Promise<any> | any
    {
        return new Promise((resolve, reject) => {
            Promise.all([
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getFaqGroups(company: any): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this._fuseConfig.api.url + '/portal/erp/' + company + '/faq/groups')
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                response => {
                    resolve(response);
                }, reject);
        });
    }

    getFaqsForGroup(company, group): Promise<any>
    {
        const params = {
            group: group
        };
        return new Promise((resolve, reject) => {
            this._httpClient.post(this._fuseConfig.api.url + '/portal/erp/' + company + '/faq/listing', params)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                response => {
                    resolve(response);
                }, reject);
        });
    }


}
